

import React, { useState, useCallback } from 'react'
import styled from 'styled-components'

import Loader from '../../../components/Loader'
import { ButtonYellowLight } from '../../Button'
import { AutoRow } from '../../../components/Row'

import useAllowanceAll from '../../../hooks/nft/useAllowanceAll'
import useUnstakeDish from '../../../hooks/nft/useUnstakeDish'
import useStakeDish from '../../../hooks/nft/useStakeDish'
import useApproveAllERC721 from '../../../hooks/nft/useApproveAllERC721'
import { stopPropagation } from '../../../utils/func'

const Button = styled(ButtonYellowLight)`
  border: 1px solid #E0DAD3;
  background-color: initial;
  color: ${({ theme }) => theme.bsText32};
  font-family: 'Roboto-Regular';
  height: 32px;
  margin-top: 19px;
`
export default function StakeBtn(
  {
    artwork, 
    gameType, 
    stakesIds,
    stakesIds2,
    stakesIds_v2,
    ids
  }:
  {
    artwork: any, 
    gameType: string,
    stakesIds?: any,
    stakesIds2?: any,
    stakesIds_v2?: any,
    ids?: any
  }) {
  const allowanceStake = useAllowanceAll({type: gameType})
  const [requestedUnstake, setRequestedUnstake] = useState(false)
  const [requestedApproval, setRequestedApproval] = useState(false)

  // approve ntf
  const onApprove = useApproveAllERC721(gameType)
  const handleApprove = useCallback(
    async (event) => {
      event.preventDefault()
      try {
        stopPropagation(event)
        setRequestedApproval(true)
        const txHash = await onApprove()
        if (!txHash) {
            setRequestedApproval(false)
        } else {
          setTimeout(() => {
            setRequestedApproval(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApprove, setRequestedApproval]
  )

  // stake
  const { onStakeDish } = useStakeDish(artwork.tokenId, gameType)
  const [requestedStake, setRequestedStake] = useState(false)
  const handleStake = useCallback(async (event) => {
    event.preventDefault()
    try {
      stopPropagation(event)
      setRequestedStake(true)
      const txHash = await onStakeDish()
      // user rejected tx or didn't go thru
      console.log(txHash)
      if (!txHash) {
        setRequestedStake(false)
      } else {
        setTimeout(() => {
          setRequestedStake(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onStakeDish])

  // unstake
  const onUnstakeDish = useUnstakeDish(artwork.tokenId, gameType)
  const onUnstakeDishV2 = useUnstakeDish(artwork.tokenId, gameType + '_V2')
  const handleUnstake = useCallback(async (event) => {
    event.preventDefault()
    try {
      stopPropagation(event)
      setRequestedUnstake(true)
      let txHash:any
      if(stakesIds_v2.includes(artwork.nftId)){
        txHash = await onUnstakeDishV2()
      }else{
        txHash = await onUnstakeDish()
      }
      // user rejected tx or didn't go thru
      if (!txHash) {
        setRequestedUnstake(false)
      } else {
        // Reset allowance
        setTimeout(() => {
          setRequestedUnstake(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onUnstakeDish, stakesIds_v2, artwork])
  
  return(
    <>
      {
        stakesIds.includes(artwork.tokenId) ?
        <Button
          onClick={handleUnstake}
          disabled={requestedUnstake}
          fontSize={14}
          height={32}
          altDisabledStyle={requestedUnstake} // show solid button while waiting
          style={{
            padding: '0',
            width: '100%'
          }}
        >
          {requestedUnstake ? (
            <AutoRow gap="6px" justify="center">
              Unstaking <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Unstake'
          )}
        </Button> :
        allowanceStake ?
        <Button
          onClick={handleStake}
          disabled={requestedStake || (artwork.price ? true : false) || stakesIds2.includes(artwork.tokenId) || ids.includes(artwork.tokenId)}
          fontSize={12}
          height={32}
          altDisabledStyle={requestedStake || (artwork.price ? true : false) || stakesIds2.includes(artwork.tokenId) || ids.includes(artwork.tokenId)} // show solid button while waiting
          style={{
            padding: '0'
          }}
        >
          {requestedStake ? (
            <AutoRow gap="6px" justify="center">
              Staking <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Stake NFT '
          )}
        </Button>
        :
        <Button
          onClick={handleApprove}
          disabled={requestedApproval || (artwork.price ? true : false)}
          fontSize={12}
          height={32}
          altDisabledStyle={requestedApproval || (artwork.price ? true : false)} // show solid button while waiting
        >
          {requestedApproval ? (
            <AutoRow gap="6px" justify="center">
              Approving <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Approve NFT'
          )}
        </Button>
      }
    </>
  )
}